"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verticalPadding = exports.useModal = exports.useDestructivePlusValidation = exports.horizontalPadding = exports.ThemeableModal = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
require("@reach/dialog/styles.css");
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _dialog = require("@reach/dialog");
var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../../utils/constants");
var _grid = require("../../layouts/grid");
var _stack = require("../../layouts/stack");
var _excluded = ["isOpen", "onDismiss", "ariaLabel"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useModal = function useModal() {
  var _React$useState = React.useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    showModal = _React$useState2[0],
    setShowModal = _React$useState2[1];
  var open = function open() {
    return setShowModal(true);
  };
  var close = function close() {
    return setShowModal(false);
  };
  return [showModal, open, close];
};
exports.useModal = useModal;
var useDestructivePlusValidation = function useDestructivePlusValidation(textToConfirm, onConfirm) {
  var _React$useState3 = React.useState(false),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    errorStatus = _React$useState4[0],
    setErrorStatus = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
    value = _React$useState6[0],
    setValue = _React$useState6[1];
  (0, React.useEffect)(function () {
    if (value === textToConfirm) {
      setErrorStatus(false);
    }
  }, [value, textToConfirm]);
  var confirmAction = function confirmAction() {
    if (value === textToConfirm) {
      onConfirm();
    } else {
      setErrorStatus(true);
    }
  };
  return {
    errorStatus: errorStatus,
    value: value,
    setValue: setValue,
    setErrorStatus: setErrorStatus,
    confirmAction: confirmAction
  };
};
exports.useDestructivePlusValidation = useDestructivePlusValidation;
var horizontalPadding = 3;
exports.horizontalPadding = horizontalPadding;
var verticalPadding = 3;
exports.verticalPadding = verticalPadding;
var ConditionalFormWrapper = function ConditionalFormWrapper(_ref) {
  var onSubmit = _ref.onSubmit,
    children = _ref.children;
  return !!onSubmit ? /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit
  }, children) : children;
};
var ThemeableModal = function ThemeableModal(props) {
  var isOpen = props.isOpen,
    onDismiss = props.onDismiss,
    onSubmit = props.onSubmit,
    children = props.children,
    ariaLabel = props.ariaLabel,
    maxWidth = props.maxWidth,
    height = props.height;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalStyle, null), /*#__PURE__*/React.createElement(_reactDraggable["default"], {
    handle: "[data-draggable-handle]"
  }, /*#__PURE__*/React.createElement(ModalContainer, (0, _extends2["default"])({
    isOpen: isOpen,
    onDismiss: onDismiss,
    ariaLabel: ariaLabel,
    $maxWidth: maxWidth
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(ConditionalFormWrapper, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(ModalContainerGrid, {
    container: true,
    $height: height,
    direction: "column",
    spacing: 3,
    wrap: 'nowrap'
  }, children)))));
};
exports.ThemeableModal = ThemeableModal;
var ThemeableModalHeader = function ThemeableModalHeader(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true,
    sx: {
      paddingLeft: horizontalPadding,
      paddingRight: horizontalPadding,
      paddingTop: verticalPadding,
      paddingBottom: verticalPadding / 2
    }
  }, /*#__PURE__*/React.createElement(DraggableHeader, {
    "data-draggable-handle": true
  }, children));
};
ThemeableModalHeader.displayName = 'ThemeableModal.Header';
ThemeableModal.Header = ThemeableModalHeader;
var ThemeableModalBody = function ThemeableModalBody(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(OverflowAutoGrid, {
    item: true,
    sx: {
      paddingLeft: horizontalPadding,
      paddingRight: horizontalPadding
    }
    // used by https://github.com/theKashey/react-focus-lock#autofocus to focus inputs only inside this container
    ,
    "data-autofocus-inside": true
  }, /*#__PURE__*/React.createElement(_stack.Stack, null, children));
};
ThemeableModalBody.displayName = 'ThemeableModal.Body';
ThemeableModal.Body = ThemeableModalBody;
var ThemeableModalFooter = function ThemeableModalFooter(props) {
  var children = props.children,
    paddingOverrides = props.paddingOverrides;
  return /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true,
    sx: _objectSpread({
      paddingLeft: horizontalPadding,
      paddingRight: horizontalPadding,
      paddingBottom: verticalPadding
    }, paddingOverrides)
  }, children);
};
ThemeableModalFooter.displayName = 'ThemeableModal.Footer';
ThemeableModal.Footer = ThemeableModalFooter;
var DraggableHeader = _styledComponents["default"].div.withConfig({
  displayName: "modals__DraggableHeader"
})(["cursor:move;"]);
var ModalStyle = (0, _styledComponents.createGlobalStyle)(["[data-reach-dialog-overlay]{z-index:", ";}@media (max-width:600px){[data-reach-dialog-overlay]{display:flex;flex-direction:column;justify-content:center;}}"], _constants.Z_INDEX_MAP.modal);
var notWithinModal = function notWithinModal(el) {
  return el.closest('[role="dialog"]') === null;
};

/*
  A lower level implementation of reach-dialog so that we can use a custom focus lock implementation.
  (See https://reach.tech/dialog/#dialogoverlay-dangerouslybypassfocuslock)

  This is necessary so we can allow elements in other open modals to be focused.
  Modal-in-a-modal is not a pattern we typically want to support, but is required if we want to support TinyMCE inside
  of a modal.
 */
var CustomFocusLockDialog = function CustomFocusLockDialog(props) {
  var isOpen = props.isOpen,
    onDismiss = props.onDismiss,
    ariaLabel = props.ariaLabel,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/React.createElement(_dialog.DialogOverlay, {
    dangerouslyBypassFocusLock: true,
    isOpen: isOpen,
    onDismiss: onDismiss
  }, /*#__PURE__*/React.createElement(_reactFocusLock["default"], {
    autoFocus: true,
    returnFocus: true,
    whiteList: notWithinModal
  }, /*#__PURE__*/React.createElement(_dialog.DialogContent, (0, _extends2["default"])({
    "aria-label": ariaLabel
  }, otherProps))));
};
var ModalContainer = (0, _styledComponents["default"])(CustomFocusLockDialog).withConfig({
  displayName: "modals__ModalContainer"
})(["&&&{width:calc(100vw - 240px);", ";box-shadow:0px 2px 6px rgba(0,0,0,0.11);border-radius:5px;padding:12px;box-sizing:border-box;@media (max-width:600px){width:calc(100vw - 48px);max-height:calc(100vh - 48px);}}&[data-reach-dialog-content]{padding:0;}"], function (props) {
  return props.$maxWidth && "max-width: ".concat(props.$maxWidth);
});
var ModalContainerGrid = (0, _styledComponents["default"])(_grid.Grid).withConfig({
  displayName: "modals__ModalContainerGrid"
})(["min-height:200px;max-height:calc(80vh - 24px);", ";"], function (props) {
  return props.$height && "height: ".concat(props.$height);
});
var OverflowAutoGrid = (0, _styledComponents["default"])(_grid.Grid).withConfig({
  displayName: "modals__OverflowAutoGrid"
})(["height:100%;overflow:auto;padding-top:12px;padding-bottom:12px;"]);